import type { IconData } from '@stacksjs/iconify-core'

export const contentCrop: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 0h4v10h10v4h-2v2h-4v-2H2V6H0V2h2z\"/><path fill=\"currentColor\" d=\"M14 8.5V2H7.5v4H10v2.5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentCrop
